import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

function PMNotice() {
  const { t } = useTranslation();
  const pmInfo = useSelector(state => state.pmNotice.info);
  return (
    <React.Fragment>
      {
        pmInfo?.noticeFlag
          ? (
            <div className="home_noti2">
              <div className="inner_box">
                {pmInfo?.noticeMessage}
              </div>
            </div>
          )
          : (
            <h1>{t('LC_01_02-GM.msg001')}</h1>
          )
      }
    </React.Fragment>
  );
}

export default PMNotice;